"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBalanceMap = void 0;
const tslib_1 = require("tslib");
const spl_token_1 = require("@solana/spl-token");
const bn_js_1 = (0, tslib_1.__importDefault)(require("bn.js"));
const tiny_invariant_1 = (0, tslib_1.__importDefault)(require("tiny-invariant"));
const _1 = require(".");
const balance_tree_1 = require("./balance-tree");
function parseBalanceMap(balances) {
    const dataByAddress = balances.reduce((memo, { address: account, earnings }) => {
        if (memo[account.toString()]) {
            throw new Error(`Duplicate address: ${account.toString()}`);
        }
        const parsedNum = new spl_token_1.u64(earnings);
        if (parsedNum.lte(new spl_token_1.u64(0))) {
            throw new Error(`Invalid amount for account: ${account.toString()}`);
        }
        memo[account.toString()] = {
            amount: parsedNum,
        };
        return memo;
    }, {});
    const sortedAddresses = Object.keys(dataByAddress).sort();
    // construct a tree
    const tree = new balance_tree_1.BalanceTree(sortedAddresses.map((address) => {
        const addressData = dataByAddress[address];
        (0, tiny_invariant_1.default)(addressData, "addressData");
        return {
            account: (0, _1.osmosisAddressToBuffer)(address),
            amount: addressData.amount,
        };
    }));
    // generate claims
    const claims = sortedAddresses.reduce((memo, address, index) => {
        const addressData = dataByAddress[address];
        (0, tiny_invariant_1.default)(addressData, "addressData");
        const { amount, flags } = addressData;
        memo[address] = Object.assign({ index, amount: amount, proof: tree.getProof(index, (0, _1.osmosisAddressToBuffer)(address), amount) }, (flags ? { flags } : {}));
        return memo;
    }, {});
    const tokenTotal = sortedAddresses.reduce((memo, key) => { var _a, _b; return memo.add((_b = (_a = dataByAddress[key]) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : new bn_js_1.default(0)); }, new bn_js_1.default(0));
    return {
        merkleRoot: tree.getRoot(),
        tokenTotal: tokenTotal.toString(),
        claims,
    };
}
exports.parseBalanceMap = parseBalanceMap;
//# sourceMappingURL=parse-balance-map.js.map